import React, { useRef, useState } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { ParagraphLRegular, ParagraphXLRegular } from '../../config/designSystem/typography';
import { animate } from '../../utils/breathe/animate';
import { delay } from '../../utils/breathe/delay';
import { interpolateTranslateY } from '../../utils/breathe/interpolate';
import { isAndroid } from '../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useOnMount } from '../../hooks/useOnMount';
import { useStores } from '../../hooks/useStores';



type Props = {
  onComplete:  () => void;
}
const interuldeInitialDelay = 600;
const interludeAnimDuration = 400;

export const ExerciceInterlude = observer( ({ onComplete } : Props) => {
  const isMounted = useRef(true);
  const [containerAnimVal] = useState(new Animated.Value(1));
  const [subtitleAnimVal] = useState(new Animated.Value(0));
  const [step, setStep] = useState(3);
  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.BREATHE;

  const showSubtitleAnimation = animate(subtitleAnimVal, {
    toValue: 1,
    duration: interludeAnimDuration,
  });

  const hideContainerAnimation = animate(containerAnimVal, {
    toValue: 0,
    duration: interludeAnimDuration,
  });






  const animateInterlude = async () => {
    await delay(interuldeInitialDelay);
    showSubtitleAnimation.start(async ({ finished }) => {
      if (!finished) return;
      await delay(1000);
      if (!isMounted.current) return;
      setStep(2);
      await delay(1000);
      if (!isMounted.current) return;
      setStep(1);
      await delay(1000);
      if (!isMounted.current) return;
      hideContainerAnimation.start(finished => finished && onComplete());
    });
  };

  useOnMount(() => {
    animateInterlude();
    return () => {
      isMounted.current = false;
      showSubtitleAnimation.stop();
      hideContainerAnimation.stop();
    };
  });

  const containerAnimatedStyle = {
    opacity: containerAnimVal.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    }),
    transform: [
      interpolateTranslateY(containerAnimVal, {
        inputRange: [0, 1],
        outputRange: [0, 8],
      }),
    ],
  };
  const subtitleAnimatedStyle = {
    opacity: subtitleAnimVal.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    }),
    transform: [
      interpolateTranslateY(subtitleAnimVal, {
        inputRange: [0, 1],
        outputRange: [0, -8],
      }),
    ],
  };

  return (
    <Animated.View style={[styles.container, containerAnimatedStyle,  !isAndroid && { zIndex:-1}, isAndroid && {zIndex:1}]}>
      <ParagraphXLRegular>{labels?.RELAX}</ParagraphXLRegular>
      <Animated.View style={subtitleAnimatedStyle}>
        <ParagraphLRegular>
          {labels?.STARTING_IN_X_SECOND.replace('{{ step }}', step)}
        </ParagraphLRegular>
      </Animated.View>
    </Animated.View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  }
});